module.exports = __webpack_public_path__ + "img/1212e_3.f1a80bb8.jpg";